export const shouldRender = (
	inEditMode: boolean,
	propertyValue: any,
): boolean =>
	inEditMode === true || (propertyValue !== undefined && propertyValue !== null)
